export enum RsvpStatus {
  'Enviado' = 1,
  'Sim' = 2,
  'Nao' = 3
}